import React from 'react';

// Función utilitaria para renderizar campos multi-valor como tarjetas
export const renderMultiValueField = (value: any, fieldName: string, className: string = '') => {
  // Campos que deben mostrarse como tarjetas
  const multiValueFields = ['colores', 'talle', 'estilo', 'genero', 'tipo', 'materiales', 'tallas', 'estilos', 'generos', 'tipos'];
  
  const isMultiValueField = (fieldName: string): boolean => {
    return multiValueFields.includes(fieldName.toLowerCase());
  };

  // Si no es un campo multi-valor, mostrar como texto normal
  if (!isMultiValueField(fieldName)) {
    if (Array.isArray(value) && value.length > 0) {
      return (
        <span className={`text-sm ${className}`}>
          {value.join(', ')}
        </span>
      );
    }
    return null;
  }

  // Para campos multi-valor, procesar el valor
  let processedValue: string[] = [];

  if (Array.isArray(value)) {
    // Si ya es un array, usarlo directamente
    processedValue = value.filter(item => item && String(item).trim() !== '');
  } else if (typeof value === 'string' && value.trim()) {
    // Si es un string, intentar dividirlo por patrones comunes
    // Primero intentar por comas
    if (value.includes(',')) {
      processedValue = value.split(',').map(item => item.trim()).filter(item => item);
    }
    // Si no hay comas, intentar por espacios o caracteres especiales
    else if (value.includes(' ') || value.match(/[A-Z][a-z]/)) {
      // Detectar patrones como "HombreNiños" y separarlos
      processedValue = value.split(/(?=[A-Z][a-z])/).map(item => item.trim()).filter(item => item);
    }
    // Si no se puede dividir, usar el valor completo
    else {
      processedValue = [value.trim()];
    }
  }

  // Si no hay valores válidos, no mostrar nada
  if (processedValue.length === 0) {
    return null;
  }

  // Mostrar como tarjetas
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {processedValue.map((item, index) => (
        <span 
          key={index} 
          className="inline-block px-2 py-1 rounded-md text-xs bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-gray-200"
        >
          {String(item)}
        </span>
      ))}
    </div>
  );
};

// Función para formatear valores simples
export const formatValue = (value: any): string => {
  if (typeof value === 'number') {
    return value.toLocaleString('es-AR');
  }
  if (typeof value === 'boolean') {
    return value ? 'Sí' : 'No';
  }
  return String(value || '');
};

// Función para detectar si un campo es multi-valor
export const isMultiValueField = (fieldName: string): boolean => {
  const multiValueFields = ['colores', 'talle', 'estilo', 'genero', 'tipo', 'materiales', 'tallas', 'estilos', 'generos', 'tipos'];
  return multiValueFields.includes(fieldName.toLowerCase());
};

// Función para procesar valores multi-valor (convierte strings concatenados en arrays)
export const processMultiValueField = (value: any, fieldName: string): string[] => {
  if (!isMultiValueField(fieldName)) {
    return Array.isArray(value) ? value : [String(value || '')];
  }

  if (Array.isArray(value)) {
    return value.filter(item => item && String(item).trim() !== '');
  }

  if (typeof value === 'string' && value.trim()) {
    // Intentar dividir por comas primero
    if (value.includes(',')) {
      return value.split(',').map(item => item.trim()).filter(item => item);
    }
    // Detectar patrones como "HombreNiños" y separarlos
    else if (value.match(/[A-Z][a-z]/)) {
      return value.split(/(?=[A-Z][a-z])/).map(item => item.trim()).filter(item => item);
    }
    // Si no se puede dividir, usar el valor completo
    else {
      return [value.trim()];
    }
  }

  return [];
};
